import { combineReducers } from 'redux';
import { FETCH_INSECTS, FETCH_INSECTS_SUCCESS } from '../actions/insectsRef';

const all = (state = [], action) => {
  switch (action.type) {
    case FETCH_INSECTS:
      return state;
    case FETCH_INSECTS_SUCCESS:
      return [...state, action.refs];
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case FETCH_INSECTS:
      return true;
    case FETCH_INSECTS_SUCCESS:
      return false;
    default:
      return state;
  }
};

const insectsRef = combineReducers({
  all,
  isFetching,
});

export default insectsRef;

export const getIsFetching = state => state.manips.insectsRef.isFetching;

export const getInsectsRef = state => state.manips.insectsRef.all[0];



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/reducers/insectsRef.js